import { Route, Routes } from 'react-router-dom';
import { CoachPage } from '@pages/coaches/coach/index';
import { CoachesList } from '@pages/coaches/coachesList';
import { CoachVideoPage } from '@pages/coaches/CoachVideoPage/index';

export const CoachesRouts = () => {
  return (
    <Routes>
      <Route path=":code">
        <Route index element={<CoachesList />} />
        <Route path=":coachId">
          <Route index element={<CoachPage />} />
          <Route path=":coachVideoId" element={<CoachVideoPage />} />
        </Route>
      </Route>
    </Routes>
  );
};
